module.exports = __webpack_public_path__ + "img/GS.f43619c3.png";